import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FilterItem {}
